module.exports = __webpack_public_path__ + "img/Princeton NZA FINAL REPORT SUMMARY (29Oct2021).pdf";